// extracted by mini-css-extract-plugin
module.exports = {"col-md-4":"AppDownloadLink_col-md-4__hcI9p","oLinksBlock":"AppDownloadLink_oLinksBlock__AxP9q","mImage":"AppDownloadLink_mImage__wtV1O","aLinks":"AppDownloadLink_aLinks__PSNfd"};